var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.25h21.374v21.374H0z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.25h21.374v21.374H0z",
    fill: "#99e1f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.374 42.626h21.25v21.25h-21.25z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.374 42.626h21.25v21.25h-21.25z",
    fill: "#99e1f4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 63.877h21.374V64H0zm0-21.25h21.374v21.25H0z",
    fill: "#1a82e2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.374 0h21.25v21.25h-21.25zm21.252 21.374H64v21.25H42.626z",
    fill: "#00b3e3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.374 42.626h21.25V21.25h-21.25z",
    fill: "#009dd9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1a82e2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.626 0H64v21.25H42.626zM42.626 21.25H64v.123H42.626z"
  }))));
}

export default SvgIcon;